"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledSystem = require("styled-system");

var _transformers = require("./transformers");

var customSystemProps = (0, _styledSystem.system)({
  cursor: true,
  fill: {
    property: "fill",
    scale: "colors"
  },
  filter: true,
  height: {
    property: "height",
    transform: _transformers.heightTransformer
  },
  listStyle: true,
  textDecoration: true,
  textOverflow: true,
  transform: true,
  transition: {
    property: "transition",
    transform: _transformers.transitionTransformer
  },
  userSelect: true,
  whiteSpace: true,
  wordBreak: true
});
var _default = customSystemProps;
exports["default"] = _default;